// extracted by mini-css-extract-plugin
export var headerXL = "BlogPostThumbnailsContainer-module--headerXL--1IRiA";
export var headerL = "BlogPostThumbnailsContainer-module--headerL--3tbsG";
export var headerM = "BlogPostThumbnailsContainer-module--headerM--1Vx-J";
export var headerS = "BlogPostThumbnailsContainer-module--headerS--2qJKu";
export var headerXS = "BlogPostThumbnailsContainer-module--headerXS--363U-";
export var blogHeaderXL = "BlogPostThumbnailsContainer-module--blogHeaderXL--30cpv";
export var blogHeaderL = "BlogPostThumbnailsContainer-module--blogHeaderL--7Xtz9";
export var blogHeaderM = "BlogPostThumbnailsContainer-module--blogHeaderM--2hNJG";
export var blogHeaderS = "BlogPostThumbnailsContainer-module--blogHeaderS--1q2Hs";
export var blogHeaderXS = "BlogPostThumbnailsContainer-module--blogHeaderXS--1zqxy";
export var headerPreamble = "BlogPostThumbnailsContainer-module--headerPreamble--5Hzwe";
export var preHeader = "BlogPostThumbnailsContainer-module--preHeader--at9Zj";
export var textNormal = "BlogPostThumbnailsContainer-module--textNormal--1wuAL";
export var textSmall = "BlogPostThumbnailsContainer-module--textSmall--42mz6";
export var textSmallAlternate = "BlogPostThumbnailsContainer-module--textSmallAlternate--2um8c";
export var legend = "BlogPostThumbnailsContainer-module--legend--1c3-c";
export var caption = "BlogPostThumbnailsContainer-module--caption--RvH88";
export var gradientBackground = "BlogPostThumbnailsContainer-module--gradientBackground--vt1vN";
export var ellipsis = "BlogPostThumbnailsContainer-module--ellipsis--1WOdG";
export var globalContainer = "BlogPostThumbnailsContainer-module--globalContainer--rPfg2";
export var maxWidth = "BlogPostThumbnailsContainer-module--maxWidth--2GMAn";
export var clipBottom = "BlogPostThumbnailsContainer-module--clipBottom--1o3P1";
export var clipTopBottom = "BlogPostThumbnailsContainer-module--clipTopBottom--1dZtF";
export var blogPostThumbnailsContainer = "BlogPostThumbnailsContainer-module--blogPostThumbnailsContainer--HUyXu";
export var postThumbnailContainer = "BlogPostThumbnailsContainer-module--postThumbnailContainer--1PoUA";
export var ch2 = "BlogPostThumbnailsContainer-module--ch2--3WB4j";
export var ch2Container = "BlogPostThumbnailsContainer-module--ch2-container--20zjY";